import React from "react";

const Checkbox = () => <ion-icon name="checkbox" />;
export default Checkbox;
